const sites = {
  ronaele: {
    id: 0,
    name: 'Ronaele',
    abrv: 'ADMIN',
    domain: 'admin.blinds.com'
  },
  bcom: {
    id: 3,
    name: 'Blinds',
    abrv: 'BCOM',
    domain: 'blinds.com'
  },
  ab: {
    id: 1,
    abrv: 'AB',
    name: 'American Blinds',
    domain: 'americanblinds.com'
  },
  jb: {
    id: 5,
    name: 'Just Blinds',
    abrv: 'JB',
    domain: 'justblinds.com'
  },
  bca: {
    id: 2,
    name: 'Blinds Canada',
    abrv: 'BCA',
    domain: 'blinds.ca'
  },
  thd: {
    id: 11,
    name: 'The Home Depot',
    abrv: 'THD',
    domain: 'homedepot.com'
  },
  thdca: {
    id: 13,
    name: 'The Home Depot Canada',
    abrv: 'THDCA',
    domain: 'homedepot.ca'
  }
};

const getSiteInfo = id => {
  let site;

  switch (id) {
    case sites.bcom.id:
      site = sites.bcom;
      break;

    case sites.ab.id:
      site = sites.ab;
      break;

    case sites.jb.id:
      site = sites.jb;
      break;

    case sites.bca.id:
      site = sites.bca;
      break;

    case sites.thd.id:
      site = sites.thd;
      break;

    case sites.ronaele.id:
      site = sites.ronaele;
      break;

    case sites.thdca.id:
      site = sites.thdca;
      break;

    default:
      site = undefined;
      break;
  }

  return site;
};

export default {};
export { getSiteInfo, sites };